/**
 * The platform's structured discard reasons (E3 RF-24, ADR-001) — mirror of the backend enum.
 * Offered inside the company's loss-reason list with `platform: true`; a deal discarded with
 * one carries it in `Card.lossReasonKey`.
 */
export enum CardDiscardReasonEnum {
  DISQUALIFIED_MQL = 'DISQUALIFIED_MQL',
  DISQUALIFIED_SQL = 'DISQUALIFIED_SQL',
  BLACKLIST = 'BLACKLIST',
}
